export type TimeRange = {
  start: string;
  end: string;
};

export enum WeekDay {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

export type WeekDayKeys = keyof typeof WeekDay;
